<script setup lang="ts">
import BaseSvg from '@clovyr/bed/components/icons/BaseSvg.vue';
</script>

<template>
  <BaseSvg class="icon icon-info" fill="none" width="20" height="20" viewBox="0 0 20 20">
    <g clip-path="url(#a)">
      <circle cx="10" cy="10" r="10" fill="#29BD7B" fill-opacity=".1" />
      <path fill="#33E672" d="M9.98 5.58a.8.8 0 1 0 0-1.58.8.8 0 0 0 0 1.58Z" />
      <path
        stroke="#33E672"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="1.2"
        d="M8 8.35h2.38v6.34m-2.38 0h4.75"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </BaseSvg>
</template>
